"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountProgress = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const account_1 = require("@src/types/account");
const company_1 = require("@src/types/company");
const styled_components_1 = require("styled-components");
const elements_1 = require("@src/components/elements");
const react_styled_1 = require("styled-breakpoints/react-styled");
const styled_breakpoints_1 = require("styled-breakpoints");
const AccountProgress_styles_1 = require("./AccountProgress.styles");
function getEmptyFieldText(emptyField) {
    switch (emptyField) {
        case account_1.AccountEmptyFieldsNames.birth_date:
            return (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "profile.resume.birth_date" });
        case account_1.AccountEmptyFieldsNames.description:
            return (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "profile.resume.description" });
        case account_1.AccountEmptyFieldsNames.profile_picture_url:
            return (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "profile.resume.profile_picture" });
        case account_1.AccountEmptyFieldsNames.telephone:
            return (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "profile.resume.phone_number" });
        case account_1.AccountEmptyFieldsNames.job:
            return (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "profile.resume.job" });
        case account_1.AccountEmptyFieldsNames.school:
            return (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "profile.resume.school" });
        case account_1.AccountEmptyFieldsNames.language:
            return (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "profile.resume.language" });
        case account_1.AccountEmptyFieldsNames.certificate:
            return (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "profile.resume.certificate" });
        case account_1.AccountEmptyFieldsNames.social_media:
            return (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "profile.resume.social_media" });
        case account_1.AccountEmptyFieldsNames.sex:
            return (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "profile.resume.gender" });
        case account_1.AccountEmptyFieldsNames.portfolio:
            return (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "profile.resume.portfolio" });
        case account_1.AccountEmptyFieldsNames.driver_licence:
            return (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "profile.resume.driver_licence" });
        case account_1.AccountEmptyFieldsNames.address:
            return (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "profile.resume.address" });
        case company_1.CompanyEmptyFieldsNames.description:
            return (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "company.about" });
        case company_1.CompanyEmptyFieldsNames.title_image_url:
            return (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "company.title_image" });
        case company_1.CompanyEmptyFieldsNames.website:
            return (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "company.website" });
        case company_1.CompanyEmptyFieldsNames.image:
            return (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "company.image" });
        default:
            break;
    }
}
function calculatePercentage(weights, emptyFields) {
    if (!weights || !Object.keys(weights).length) {
        return;
    }
    const weightsSum = Object.values(weights).reduce((previousValue, currentValue) => previousValue + currentValue);
    let notFilledFieldsWeightSum = 0;
    if (emptyFields && emptyFields.length > 0) {
        emptyFields.forEach(field => {
            if (weights[field]) {
                notFilledFieldsWeightSum += weights[field];
            }
        });
    }
    const filledFieldsWeightSum = weightsSum - notFilledFieldsWeightSum;
    const actualPercentage = Math.floor((filledFieldsWeightSum * 100) / weightsSum);
    return actualPercentage;
}
const EmptyFieldsText = ({ emptyFieldNames, link }) => {
    if (!emptyFieldNames) {
        return null;
    }
    const maxAllowedFieldsToShow = 2;
    const isBelowSm = (0, react_styled_1.useBreakpoint)((0, styled_breakpoints_1.down)('sm'));
    if (isBelowSm) {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)(AccountProgress_styles_1.EmptyFieldsWrapper, { children: [(0, jsx_runtime_1.jsx)(AccountProgress_styles_1.ProgressText, { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "profile.empty_fields" }) }), (0, jsx_runtime_1.jsx)("div", { children: emptyFieldNames === null || emptyFieldNames === void 0 ? void 0 : emptyFieldNames.map((fieldName, index) => {
                    if (index >= maxAllowedFieldsToShow) {
                        return null;
                    }
                    const fieldText = getEmptyFieldText(fieldName);
                    if (!fieldText) {
                        return null;
                    }
                    return ((0, jsx_runtime_1.jsx)(AccountProgress_styles_1.RoundedButton, { size: "small", type: "default", link: link, children: fieldText }, fieldName));
                }) })] }));
};
const LineProgress = ({ title, filledProfilePercentage, lineColor, trailColor, linkPath, onHideForeverButtonClick, emptyFieldNames, isLoading, }) => {
    return ((0, jsx_runtime_1.jsxs)(AccountProgress_styles_1.Container, { children: [(0, jsx_runtime_1.jsxs)(AccountProgress_styles_1.ProgressWrapper, { children: [(0, jsx_runtime_1.jsx)(AccountProgress_styles_1.ProgressText, { children: title }), (0, jsx_runtime_1.jsx)(elements_1.Progress, { percent: filledProfilePercentage === 0 ? 0.5 : filledProfilePercentage, strokeColor: lineColor, trailColor: trailColor })] }), filledProfilePercentage !== 100 && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(EmptyFieldsText, { emptyFieldNames: emptyFieldNames, link: linkPath }), (0, jsx_runtime_1.jsxs)(AccountProgress_styles_1.Buttons, { children: [(0, jsx_runtime_1.jsx)(elements_1.Button, { className: "p-s", size: "small", type: "primary", link: linkPath, children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "profile.change_profile" }) }), (0, jsx_runtime_1.jsx)(AccountProgress_styles_1.Brand5Button, { size: "small", type: "default", onClick: () => onHideForeverButtonClick(), loading: isLoading, children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "profile.never_show" }) })] })] }))] }));
};
const AccountProgress = ({ title, weights, emptyFields, linkPath, onCancel, onHideForeverButtonClick, isLoading, }) => {
    const filledProfilePercentage = react_1.default.useMemo(() => calculatePercentage(weights, emptyFields), [emptyFields]);
    const theme = (0, styled_components_1.useTheme)();
    const lineColor = `linear-gradient(to right, ${theme.color.brand1}, #8FA5C2)`;
    if (!filledProfilePercentage || filledProfilePercentage === 100) {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)(AccountProgress_styles_1.StyledPanel, { children: [(0, jsx_runtime_1.jsx)(AccountProgress_styles_1.ProgressBox, { children: (0, jsx_runtime_1.jsx)(LineProgress, { title: title, filledProfilePercentage: filledProfilePercentage, lineColor: lineColor, linkPath: linkPath, onHideForeverButtonClick: onHideForeverButtonClick, trailColor: theme.color.brand5, emptyFieldNames: emptyFields, isLoading: isLoading }) }), (0, jsx_runtime_1.jsx)(AccountProgress_styles_1.CloseWrapper, { onClick: onCancel, children: (0, jsx_runtime_1.jsx)(AccountProgress_styles_1.CloseIcon, {}) })] }));
};
exports.AccountProgress = AccountProgress;
